import { render, staticRenderFns } from "./TemplateMessageTags.vue?vue&type=template&id=54b59e02"
import script from "./TemplateMessageTags.vue?vue&type=script&lang=js"
export * from "./TemplateMessageTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports